import React, { useEffect, useState } from "react";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ChannelInsituteForm from "../component/ChannelInstituteForm";

const ChannelPartnerInstitute = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await ChannelService.getAssignList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await ChannelService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Channel Partners" pageTitle="KEF Intelligence" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button className="btn btn-success" onClick={toggleModal}>
              <i className="bi bi-plus-lg"></i> New Partner
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="2" className="">
          {data?.map((item, index) => {
            return (
              <Col key={item.id}>
                <Card>
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <CardImg
                      top
                      src={`${imageBaseApi}${item?.channelPartnerLogo?.url}`}
                      alt={item.fileName}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>

                  <CardBody>
                    <p>{item?.channelPartnerName}</p>

                    <h5 className="fw-bold">Assign Institute:</h5>

                    <div className="d-flex align-items-center gap-4 flex-wrap">
                      {item?.universities?.slice(0, 7).map((uni, index) => (
                        <img
                          key={index}
                          src={`${imageBaseApi}${uni?.universityLogoUrl?.url}`}
                          className="avatar-lg object-fit-contain"
                          alt="university-logo"
                        />
                      ))}

                      {item?.universities?.length > 7 && (
                        <div
                          className="avatar-lg d-flex align-items-center justify-content-center bg-light text-primary fw-semibold cursor-pointer"
                          onClick={() =>
                            navigate(`/channel-partner/${item.id}`)
                          }
                        >
                          +{item.universities.length - 8}
                        </div>
                      )}
                    </div>
                  </CardBody>

                  {/* <CardFooter>
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => toggleModal(item)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>

                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                  </CardFooter> */}
                </Card>
              </Col>
            );
          })}
        </Row>

        <ChannelInsituteForm
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />

        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default ChannelPartnerInstitute;
